import React from 'react';
import { useAuthContext } from 'store';
import dynamic from 'next/dynamic';

const OrganizationEdit = dynamic(import('./OrganizationEdit'));

type Props = { organization: MorressierOrganization };

const OrganizationEditLoader = (props: Props) => {
  const { state: authState } = useAuthContext();
  const authUser = authState?.profile;

  const show = authUser?.org_admin_in?.includes(props.organization.id);

  return <>{show ? <OrganizationEdit organization={props.organization} /> : null}</>;
};

export default OrganizationEditLoader;
